import { render, staticRenderFns } from "./TemplateRenderPublic.vue?vue&type=template&id=3539bd49&scoped=true&"
import script from "./TemplateRenderPublic.vue?vue&type=script&lang=ts&"
export * from "./TemplateRenderPublic.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateRenderPublic.vue?vue&type=style&index=0&id=3539bd49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3539bd49",
  null
  
)

export default component.exports